import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'timeSinceNow',
    standalone: false,
})
export class TimeSinceNowPipe implements PipeTransform {
    transform(time: string): string {
        return moment.duration(moment(time).diff(moment())).humanize(true);
    }
}
